import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SearchAuditResponse, SearchTasksResponse, BatchDetailsResponse, AgentAuditDetailsResponse, TransactionDetailsResponse, AgentRecord } from '../models/dashboard.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly config = {
    apiUrl: `https://${environment.COMMUNIC8_DOWNLOAD_API_URL}`
  }
  public readonly PAGE_SIZE = 25;
  public readonly PAGE_SIZE_OPTIONS = [10, 25, 50];
  public previousPageSize = this.PAGE_SIZE;
  
  constructor(private http: HttpClient) { }

  searchTasks(body) {
    return this.http.post<SearchTasksResponse>(`${this.config.apiUrl}/communic8/search-tasks`, body);
  }

  searchAudit(body) {
    return this.http.post<SearchAuditResponse>(`${this.config.apiUrl}/communic8/search-audit`, { body });
  }

  getBatchDetails(body) {
    return this.http.post<BatchDetailsResponse>(`${this.config.apiUrl}/communic8/dashboard/batch-details`, body);
  }
  
  getTransactionDetails(body) {
    return this.http.post<TransactionDetailsResponse>(`${this.config.apiUrl}/communic8/dashboard/transaction-details`, body);
  }

  getAgentAuditDetails(body) {
    return this.http.post<AgentAuditDetailsResponse>(`${this.config.apiUrl}/communic8/dashboard/agent-details`, body);
  }

  retryBatch(body) {
    return this.http.post<any>(`${this.config.apiUrl}/communic8/dashboard/retry-batch`, body);
  }

  updateAgents(body) {
    return this.http.post<AgentRecord[]>(`${this.config.apiUrl}/communic8/agents`, body);
  }

  getAllAgents() {
    return this.http.get<AgentRecord[]>(`${this.config.apiUrl}/communic8/agents`);
  }

}
